import React, { useEffect, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {Form, Button} from 'react-bootstrap';
import api from '../../../services/api';
import { toast } from 'react-toastify';

const AudioMatchingServerForm = (props) => {
    const [Name, setName] = useState('');
    const [Hostname, setHostname] = useState('');
    const [ApiKey, setApiKey] = useState('');
    const [HasApiKey, setHasApiKey] = useState(false);
    const [Enabled, setEnabled] = useState(true);
    const [id, setId] = useState(props?.location?.aboutProps?.id);
    const [loadingData, setLoadingData] = useState(false);
    const history = useHistory();

    const getById = async () => {
        if (id > 0) {
            setLoadingData(true);
            try {
                api.get("amserver/" + id)
                    .then(function (response) {
                        if (response.status == 200) {
                            var result = response.data;
                            setName(result.name);
                            setHostname(result.hostname);
                            setHasApiKey(result.has_api_key);
                            setEnabled(result.is_active);
                        }
                        setLoadingData(false);
                    })
                    .catch(function (error) {
                        toast.error('An error occurred !', {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setLoadingData(false);
                    });
            } catch (err) {
                toast.error('An error occurred !', {
                    position: toast.POSITION.TOP_RIGHT
                });
                setLoadingData(false);
            }
        }
    }

    const saveData = async (e) => {
        e.preventDefault();
        setLoadingData(true);
        const payload = {
            name: Name,
            hostname: Hostname,
            is_active: Enabled
        };
        // Only send the key when the user typed one, so an untouched field
        // keeps the server's existing key on edit (partial update).
        if (ApiKey !== '') {
            payload.api_key = ApiKey;
        }
        const onError = (error) => {
            const detail = error?.response?.data;
            const message = detail && typeof detail === 'object'
                ? Object.values(detail).flat().join(' ')
                : 'An error occurred !';
            toast.error(message, {
                position: toast.POSITION.TOP_RIGHT
            });
            setLoadingData(false);
        };
        try {
            if (id > 0) {
                api.put('amserver/' + id, payload)
                    .then(function (response) {
                        if (response.status == 200 || response.status == 204) {
                            toast.success('Successful Operation !', {
                                position: toast.POSITION.TOP_RIGHT
                            });
                            return history.push('/admin/amservers');
                        }
                    })
                    .catch(onError);
            } else {
                api.post('amserver', payload)
                    .then(function (response) {
                        if (response.status == 200 || response.status == 204) {
                            toast.success('Successful Operation !', {
                                position: toast.POSITION.TOP_RIGHT
                            });
                            return history.push('/admin/amservers');
                        }
                    })
                    .catch(onError);
            }
        } catch (err) {
            setLoadingData(false);
        }
    }

    useEffect(() => {
        getById();
        var selector = document.getElementById('title-section-id');
        if (selector != undefined) {
            if (id > 0)
                selector.textContent = "Edit Audio Matching Server";
            else
                selector.textContent = "Create Audio Matching Server";
        }
    }, []);

    return (
        <>
            <div className={loadingData ? "preload" : "d-none"}><div className="preloader-spinner"></div></div>
            <Form className="create-form" onSubmit={saveData} autoComplete="off">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control name="name" type="text" required placeholder='e.g. Client X Production' value={Name} onChange={(e) => setName(e.target.value)} />
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Hostname</Form.Label>
                                    <Form.Control name="hostname" type="text" required placeholder='am.example.com' value={Hostname} onChange={(e) => setHostname(e.target.value)} />
                                    <small className="form-text text-muted">Host of the audio-matching backend (https is assumed; no scheme or path).</small>
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Admin API Key</Form.Label>
                                    <Form.Control name="api_key" type="password" placeholder={HasApiKey ? '••••••••  (leave blank to keep)' : 'Optional'} value={ApiKey} onChange={(e) => setApiKey(e.target.value)} />
                                    <small className="form-text text-muted">Sent as X-Api-Key when registering streams. Leave blank to use the platform default key.</small>
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Enabled</Form.Label>
                                    <Form.Check name="Enabled" type="checkbox" checked={Enabled} onChange={(e) => setEnabled(!Enabled)} />
                                    <small className="form-text text-muted">Disabled servers cannot be selected for new streams.</small>
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-12 footer-form">
                                <NavLink className="btn btn-secondary" to="/admin/amservers"><i className="fa fa-fw fa-times"></i> Cancel</NavLink>
                                <Button className="btn btn-primary" type='submit'><i className="fa fa-fw fa-floppy-o"></i> Save</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </>
    );
};

export default AudioMatchingServerForm;
